import { poppins_400, poppins_500, poppins_600 } from "@/components/common/fonts";
import { WORKSPACE_USER_TYPE, WorkspaceUserType } from "@/constants/dashboard/workspace";
import { Dropdown, Modal } from "antd";
import styled from "styled-components";

export const MenuWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  >span {
    font-size: 12px;
    font-family: ${poppins_400.style.fontFamily};
    font-weight: 400;
    line-height: 20px;
    color: #000000;
  }

  .title {
    font-size: 16px;
    line-height: 24px;
    font-family: ${poppins_600.style.fontFamily};
    font-weight: 600;
  }
`;

export const CustomCreateWorkspaceModal = styled(Modal)`
  h1.ant-typography {
    font-family: ${poppins_600.style.fontFamily};
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
  }

  .content {
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
    font-family: ${poppins_400.style.fontFamily};

    >span {
      color: #3075f6;
    }
  }

  .form-content {
    height: 130px;
    background-color: #f8f9fa;
    border-radius: 5px;
    padding: 20px 10px;
    gap: 10px;
    margin: 10px 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* display: flex;
    align-items: flex-start;
    flex-wrap: wrap; */

    >span {
      font-size: 12px;
      line-height: 8px;
      font-weight: 400;
      font-family: ${poppins_400.style.fontFamily};
    }

    /* .rtl--input &::placeholder {
      color: rgba(68, 68, 68, 0.5);
    } */
  }

  .send-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;

    .send {
      /* border-radius: 100px; */
      gap: 5px;
      height: 30px;
      width: 100px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0px 10px;
      background-color: #3075f6;
      border: 1px solid #3075f6;

      &[disabled] {
        border: 1px solid #dedede;
        background-color: #dedede; 
        color: #fff; 
      }
      
      >span {
        font-size: 12px;
        line-height: 16px;
        font-family: ${poppins_500.style.fontFamily};
        font-weight: 500;
      }
    }
  }

`;

export const CustomInviteWorkspaceModal = styled(Modal)`
  h1.ant-typography {
    /* font-family: ${poppins_600.style.fontFamily}; */
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
  }

  .content {
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
    font-family: ${poppins_400.style.fontFamily};
    margin: 20px 0px;

    >span {
      color: #3075f6;
    }
  }

  .form-content {
    height: 30px;
    background-color: #f8f9fa;
    border-radius: 5px;
    padding: 20px 10px;
    gap: 10px;
    margin: 20px 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* display: flex;
    align-items: flex-start;
    flex-wrap: wrap; */

    .input-wrapper {
      box-sizing: border-box;
      margin: 0;
      padding: 3px 7px;
      font-size: 12px;
      line-height: 10px;
      list-style: none;
      /* position: relative; */
      display: inline-block;
      width: 100%;
      min-width: 0;
      border-radius: 6px;
      transition: all 0.2s;
      background: #ffffff;
      height: 60px;

      display: flex;
      
      .input-email {
        flex: 3;
        /* background-color: aliceblue; */
      }

      .select-type {
        flex: 1;
        width: 100%;
      }
    }

    .checkEmail {
      width: 100%;
      height: 20px;
      color: red;
      padding: 0px 10px;
    }

    >span {
      font-size: 12px;
      line-height: 8px;
      font-weight: 400;
      font-family: ${poppins_400.style.fontFamily};
    }
  }
  
  .send-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 5px;

    .copy {
      /* border-radius: 100px; */
      gap: 5px;
      height: 40px;
      width: 180px;
      color: #444444;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0px 10px;
      background-color: #ffffff;
      border: 1px solid #dedede;

      &[disabled] {
        border: 1px solid #dedede;
        background-color: #dedede;
        color: #fff; 
      }
      
      >span {
        font-size: 14px;
        line-height: 10px;
        /* font-weight: 600; */
      }
    }

    .send {
      /* border-radius: 100px; */
      gap: 5px;
      height: 40px;
      width: 180px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0px 10px;
      background-color: #3075f6;
      border: 1px solid #3075f6;

      &[disabled] {
        border: 1px solid #dedede;
        background-color: #dedede;
        color: #fff;
      }
      
      >span {
        font-size: 14px;
        line-height: 10px;
        font-weight: 600;
      }
    }
  }
`;

export const CustomDropdownButton = styled(Dropdown.Button)`
  border: none;
  box-shadow: 0px;
  border-color: #ffffff;

  &:hover {
    border-color: #ffffff;
    background-color: #ffffff;
    border: none;
  }
  &:active {
    border-color: #ffffff;
    background-color: #ffffff;
    border: none;
  }

  >ant-btn {
    border-color: #ffffff;
    background-color: #ffffff;
    border: none;
  }

  .ant-btn-default {
    border-color: #ffffff;
    background-color: #ffffff;
    border: none;
    box-shadow: 0px;

  }
`;

export const CustomDropdownContainer = styled.div`
  width: 280px;
  height: 170px;
  z-index: 999;
  box-shadow: 0px 4px 10px 0px #00000040;
  background-color: #ffffff;
  border-radius: 8px;
`;

export const CustomDropdownItemContainer = styled.div<{ $selected: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  background-color: ${({ $selected }) => ($selected) ? '#f1f1f1' : '#ffffff'};
  padding: 16px;
  border-radius: 8px;
  cursor: pointer;
`

export const CustomDropdownItem = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  span {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }
`;